import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-chair-workouts-al',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-chair-workouts-m', 'age-chair-workouts-m'],
		route: {
			path: '/chair-workouts-m-al',
			name: 'male-chair-workouts-funnel-al',
		},
	},
	funnel: {
		id: 'ob-male-chair-workouts-al',
		route: {
			path: '/chair-workouts-m-al/ob/:page(.*)?',
			name: 'activity-male-chair-workouts-al',
		},
		slug: 'activity-male-chair-workouts-al',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-chair-workouts-m-al',
	},
	upsell: {
		routeNames: ['upsell-activity-m'],
	},
}

export default appAreaConfig
